/** Public site code: lowercase alphanumeric + hyphens, 3–64 chars. Not a secret. */
export const SITE_CODE_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const SITE_CODE_MIN = 3;
export const SITE_CODE_MAX = 64;
export function isValidSiteCode(code) {
    const trimmed = code.trim();
    return (trimmed.length >= SITE_CODE_MIN &&
        trimmed.length <= SITE_CODE_MAX &&
        SITE_CODE_PATTERN.test(trimmed));
}
export function normalizeSiteCode(code) {
    return code.trim().toLowerCase();
}
//# sourceMappingURL=site.js.map